import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { GlobalService } from '../global.service';
import { Avaliacao } from '../../model/avaliacao';

@Injectable()
export class AvaliacaoApiService {

    constructor(
        public http: HttpClient, 
        private globalService: GlobalService
    ) {
    }

    public enviarAvaliacao(avaliacao: Avaliacao): Observable<any> {
        let url = this.globalService.getConfiguracao().api_painel + "/avaliacao";
        let data = JSON.stringify(avaliacao);
        
        return this.http.post(url, data, {headers: {'Content-Type': 'application/json; charset=utf-8'}});
    }

    public buscarUltimaAvaliacao(usuario: string, nomeApp: string): Observable<Avaliacao> {
        let url = this.globalService.getConfiguracao().api_painel + "/avaliacao/ultima/" + usuario + "/" + nomeApp + "/";
        
        return this.http.get<Avaliacao>(url, {headers: { 'Content-Type': 'application/json; charset=utf-8'}});
    }

    
}


// WEBPACK FOOTER //
// ./src/service/api/avaliacao.api.ts